import { FilterDateRange } from "@/presentation/deduction/components/DeductionFilter/interfaces";
import {
  calculateFromDateByMonths,
  convertDateRangeToDates,
  DATE_CONSTANTS,
} from "@/presentation/deduction/components/DeductionFilter/utils/dateCalculations";
import { AnalyticsFilterInfo } from "./analytics.atoms";

export const ANALYTICS_DEFAULT_DATE_RANGE_IN_MONTHS = 3;

export const getEmptyAnalyticsFilterInfo = (): AnalyticsFilterInfo => ({
  checkFromDate: null,
  checkToDate: null,
  checkDateRange: null,
  invoiceFromDate: null,
  invoiceToDate: null,
  invoiceDateRange: null,
  purchaser: [],
});

export const getDefaultAnalyticsFilterInfo = (): AnalyticsFilterInfo => ({
  ...getEmptyAnalyticsFilterInfo(),
  checkDateRange: FilterDateRange.LAST_3_MONTHS,
  checkFromDate: calculateFromDateByMonths(ANALYTICS_DEFAULT_DATE_RANGE_IN_MONTHS),
  checkToDate: DATE_CONSTANTS.currentDateFormatted,
});

export const hasAnalyticsPresetDateRange = (filter: AnalyticsFilterInfo): boolean =>
  Boolean(filter.checkDateRange ?? filter.invoiceDateRange);

export const areAnalyticsFilterDatesStale = (
  filter: AnalyticsFilterInfo,
  resolved: AnalyticsFilterInfo
): boolean =>
  filter.checkFromDate !== resolved.checkFromDate ||
  filter.checkToDate !== resolved.checkToDate ||
  filter.invoiceFromDate !== resolved.invoiceFromDate ||
  filter.invoiceToDate !== resolved.invoiceToDate;

export const resolveAnalyticsFilterInfo = (filter: AnalyticsFilterInfo): AnalyticsFilterInfo => {
  let resolved = { ...filter };

  if (filter.checkDateRange) {
    const { fromDate, toDate } = convertDateRangeToDates(
      filter.checkDateRange,
      ANALYTICS_DEFAULT_DATE_RANGE_IN_MONTHS
    );
    resolved = { ...resolved, checkFromDate: fromDate, checkToDate: toDate };
  }

  if (filter.invoiceDateRange) {
    const { fromDate, toDate } = convertDateRangeToDates(
      filter.invoiceDateRange,
      ANALYTICS_DEFAULT_DATE_RANGE_IN_MONTHS
    );
    resolved = { ...resolved, invoiceFromDate: fromDate, invoiceToDate: toDate };
  }

  return resolved;
};
